import EnhancedExperienceNotice, {
  getEnhancedExperienceURL
} from './EnhancedExperienceNotice';

export { getEnhancedExperienceURL };
export default EnhancedExperienceNotice;
